<template>
    <app-container class="timeline-page">
        <timeline-header :total="total" :tag-name="currentTag.description"/>
        <!-- 标签列表 -->
        <timeline-tag-list :tag-list="tagList"
                           :current="currentTag"
                           v-observe-visibility="{callback: handleTagListVisibleChange}"
        />
        <!-- fixed 组件 -->
        <div class="timeline-page__fixed-box" v-show="showFixed">
            <div class="timeline-page__fixed-box-inner">
                <timeline-tag-list :tag-list="tagList"
                                   :current="currentTag"
                />
            </div>
        </div>
        <div class="timeline-page__container">
            <timeline-skeleton v-if="!dataList.length"/>
            <template v-for="item in dataList">
                <timeline-year :key="item.title" :data="item"/>
            </template>


            <!-- load more -->
            <div class="timeline-page__loading"
                 v-observe-visibility="{
                      callback: handleLoadList,
                      throttle: 250
            }">
                <app-button class="timeline-page__load-more"
                            v-if="showLoadMore"
                            @click="handleLoadList(true,true)">
                    加载更多
                    <app-icon value="icon-enter"/>
                </app-button>
                <app-loading v-if="loading"/>
            </div>
        </div>
    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import TimelineYear from '@components/TimelineYear'
    import AppLoading from '@components/AppLoading'
    import TimelineHeader from './components/TimelineHeader'
    import AppIcon from '@components/AppIcon'
    import AppButton from '@components/AppButton'
    import TimelineSkeleton from '@assets/svg/inline.timeline-skeleton.svg'

    import getTagListService from '@service/getTagListService'
    import TimelineTagList from './components/TimelineTagList'

    import {formatDate} from '@utils'
    import {DEFAULT_LIMIT} from '@config'

    import getTimelineService from '@service/getTimelineService'

    export default {
        name: "TimeLine",
        data() {
            return {
                loading: false,
                error: false,
                index: 0,
                limit: DEFAULT_LIMIT,
                total: 0,
                tagList: [],
                dataList: [],
                showFixed: false
            }
        },
        computed: {
            tagId() {
                const params = this.$route.query
                return params.tag || ''
            },
            currentTag() {
                let {tagList, tagId} = this
                tagList = tagList || []
                if (tagId) {
                    for (let i = 0; i < tagList.length; i++) {
                        const item = tagList[i]
                        if (item.id === tagId) {
                            return {...item}
                        }
                    }
                    return {
                        id: tagId,
                        name: 'undefined',
                        description: '未知'
                    }
                }
                return {
                    id: '',
                    name: 'all',
                    description: '全部'
                }
            },
            showLoadMore() {
                const {loading, error, limit, index, total} = this
                if (index === 0) {
                    return (total === 0 && !loading && error)
                } else {
                    const current = (index + 1) * limit
                    // 当前数量小于分页数量，并且错误 并且不在加载中
                    return ((current < total) && !loading && error)
                }
                // !loading&&error
            },
        },
        watch: {
            tagId: {
                handler() {
                    this.dataList = []
                    this.getTimeline()
                },
                immediate: true
            }
        },
        mounted() {
            this.getTagList()
        },
        methods: {
            async getTagList() {
                const list = await getTagListService()
                this.tagList = list
            },
            async getTimeline(index = 0) {
                try {
                    this.loading = true
                    const {limit, tagId} = this
                    const {data, limit: dataLimit, total, index: dataIndex} = await getTimelineService({
                        tagId,
                        index,
                        limit
                    })
                    this.total = total
                    this.limit = dataLimit
                    this.index = dataIndex
                    this.formatData(data)
                    this.error = false
                } catch (e) {
                    this.error = true
                } finally {
                    this.loading = false
                }
            },
            handleTagListVisibleChange(visible) {
                this.showFixed = !visible
            },
            handleLoadList(isVisible, flag) {
                const {loading} = this
                if (isVisible && !loading) {
                    const {index, limit, total} = this
                    if ((((index + 1) * limit) < total) || flag === true) {
                        this.getTimeline(index + 1)
                    }

                }
            },
            formatData(data) {
                let {dataList} = this
                // 年指针
                let yearPointer = data.length - 1
                let yearData = dataList[yearPointer]

                // 月指针
                let monthPointer = yearData ? yearData.child.length - 1 : -1
                let monthData = yearData ? yearData.child[monthPointer] : undefined

                data.forEach((item) => {
                    const {publishDate} = item
                    const [year, month] = (formatDate(new Date(publishDate), 'yyyy-MM-dd')).split('-')
                    // 判断 没有年数据 或者 年份与当前数据不一致
                    // 则创建当前年数据
                    // 修改 年指针
                    // 修改 月指针
                    if (!yearData || yearData.title !== year) {
                        dataList.push({
                            title: year,
                            child: []
                        })
                        yearPointer = dataList.length - 1
                        yearData = dataList[yearPointer]
                        monthPointer = -1
                        monthData = undefined
                    }
                    // 判断 没有月数据 或者 月份与当前数据不一致
                    // 则创建当前月数据
                    // 修改 月指针
                    if (!monthData || monthData.title !== month) {
                        dataList[yearPointer].child.push({
                            title: month,
                            child: []
                        })
                        monthPointer = dataList[yearPointer].child.length - 1
                        monthData = dataList[yearPointer].child[monthPointer]
                    }
                    // 添加数据
                    dataList[yearPointer].child[monthPointer].child.push(item)
                })
            }
        },
        components: {
            AppContainer,
            TimelineHeader,
            TimelineYear,
            TimelineTagList,
            AppLoading,
            TimelineSkeleton,
            AppIcon,
            AppButton
        }
    }


</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .timeline-page {
        padding: $paddingSP*2 $paddingMD $paddingSP;
        max-width: 800px;

        &__container {
            padding: $paddingMD;
            background-color: $componentBackgroundColor;
            background-color: var(--componentBackgroundColor);
            border-radius: $radius;
            @include transition-colors;
            .app-inline-svg{
                fill: $componentHighLightColor;
                fill: var(--componentHighLightColor);
            }
        }

        &__tag-list {
            padding: $paddingMD 0 $paddingBase 0;
        }

        &__fixed-box {
            position: fixed;
            top: $headerHeight;
            left: 0;
            right: 0;
            z-index: 999;
            box-shadow:  0 10px 8px rgba(0, 0, 0, .101562);;
            background-color: $backgroundColor;
            background-color: var(--backgroundColor);
            @include transition-colors;

            &-inner {
                padding: 0 $paddingMD;
                max-width: 800px;
                margin: 0 auto;
            }
        }

        &__loading {
            margin-top: $paddingMD;
            text-align: center;
        }

        &__load-more {
            font-size: $fontSizeCommon;
        }
    }

</style>